import routerOptions0 from "/src/client/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@20.19.33_@vue+compiler-sfc@3.5.28_cac@6.7._b7771587fed2e73b785cd7312d8df32a/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}